import { CollectionRef } from "@/types/collection"
import { PlaceRef } from "@/types/entity"
import { SavedSearchResults } from "@/types/page"
import { FavoritePlace, PlacePlaceholder } from "@/types/place"
import { BoundingBox } from "@/types/util"

import { BaseApi } from "@/lib/base-api"
import { DEFAULT_PLACES_PER_PAGE } from "./paging"

export interface FetchSavedPlaceArgs {
  page?: number
  perPage?: number
}

export class SavedPlaceApi extends BaseApi {
  async type_search(
    type: string,
    search_string: string,
    bbox?: BoundingBox,
    page = 1,
    per_page: number = DEFAULT_PLACES_PER_PAGE
  ) {
    const query = new URLSearchParams()
    if (search_string) {
      query.append("search_string", search_string)
    }

    if (bbox) {
      query.append("min_lat", bbox[0].toString())
      query.append("max_lat", bbox[1].toString())
      query.append("min_long", bbox[2].toString())
      query.append("max_long", bbox[3].toString())
    }

    query.append("page", page.toString())
    query.append("per_page", per_page.toString())

    return await this.get<SavedSearchResults>(
      `/api/favorite_places/type_search/${type}?${query}`
    )
  }

  async fetchMapMarkers() {
    return await this.get<{ data: PlacePlaceholder[] }>(
      "/api/favorite_places/map_markers"
    )
  }

  async updateNote(
    placeRef: PlaceRef,
    collectionRef: CollectionRef,
    note?: string
  ) {
    const data = await this.put<{ favorite_place: FavoritePlace }>(
      `/api/favorite_places/${placeRef}/note`,
      {
        collection_ref: collectionRef,
        note,
      }
    )
    return data.favorite_place
  }

  async deleteSourceSummary(placeRef: PlaceRef, collectionRef: CollectionRef) {
    const data = await this.delete<{ favorite_place: FavoritePlace }>(
      `/api/favorite_places/${placeRef}/source_summary?collection_ref=${collectionRef}`
    )
    return data.favorite_place
  }
}
